import {
    type Material,
} from 'three';
import { makeBasicMaterial, type BasicMaterialParams } from '@/lib/threeScene/materials/basicMaterial';
import {
    makeStandardMaterial,
    type StandardMaterialParams,
} from '@/lib/threeScene/materials/standardMaterial';
import { makePhongMaterial, type PhongMaterialParams } from '@/lib/threeScene/materials/phongMaterial';
import { makeXrayMaterial, type XrayMaterialParams } from '@/lib/threeScene/materials/xrayMaterial';

type _MaterialParams =
    | BasicMaterialParams
    | StandardMaterialParams
    | PhongMaterialParams
    | XrayMaterialParams;

export type MaterialParams = Partial<_MaterialParams> & { type: _MaterialParams['type'] };

/**
 * Create a three.js {@link Material} reflecting the given parameters
 */
export function makeMaterial(parameters: MaterialParams): Material {
    switch (parameters.type) {
        case 'basic':
            return makeBasicMaterial(parameters);
        case 'standard':
            return makeStandardMaterial(parameters);
        case 'phong':
            return makePhongMaterial(parameters);
        case 'xray':
            return makeXrayMaterial(parameters);
        default:
            throw Error(`Unknown material type: ${(parameters as { type: unknown }).type}`);
    }
}
